module.exports = __webpack_public_path__ + "img/diminished-value-protection@2x.d695b656.jpg";